import formatProductLabelsForAnalytics from './formatProductLabelsForAnalytics'


const getQueueAddItemProduct = (product: ProductFragment.Base, isEcommerce?: boolean, isFullSizeBottlePrioritized?: boolean): QueueModule.AddItemProduct => {
  const {
    id,
    tradingItems,
    image,
    rebrandImage,
    name,
    brandInfo: { name: brand },
    category,
    gender,
    upchargePrice,
    isSubscribedToStockNotification,
    theEdit,
  } = product

  const isEcommerceProduct = (
    isEcommerce === true
    || tradingItems?.items?.[0]?.section !== 'Subscription'
  )

  const regularEcommerceTradingItem = isEcommerceProduct && tradingItems?.items?.find(({ section }) => section !== 'Subscription')
  const fullSizeBottleTradingItem = isFullSizeBottlePrioritized && tradingItems?.items?.find(({ section, type }) => section === 'Ecommerce' && type === 'PerfumeBottle')
  const subscriptionTradingItem = !isEcommerceProduct && tradingItems?.items?.find(({ section }) => section === 'Subscription')

  const tradingItem = subscriptionTradingItem || fullSizeBottleTradingItem || regularEcommerceTradingItem

  return {
    productId: id,
    tradingItemId: tradingItem?.id,
    name,
    brand,
    category,
    gender,
    image,
    rebrandImage,
    productLabels: formatProductLabelsForAnalytics(product),
    upchargePrice,
    isLimitedEdition: tradingItem?.isLimitedEdition,
    isSubscribedToStockNotification,
    theEdit,
  }
}


export default getQueueAddItemProduct
